import NoInlineResultSearcher from "./NoInlineResultSearchers"

class JstorSearcher extends NoInlineResultSearcher {
    key = 'JSTOR';
    searcherName = 'JSTOR';
    infoText = 'JSTOR';
    typeFilter2urlSection = {"All types": null};
    multiTypeFilterSupported = false;
    dateFilterSupported = false;

    fillTargetWebsiteUrl(value, store) { 
        this.targetWebsiteUrl = "https://www.jstor.org/action/doBasicSearch?Query=" +
        encodeURIComponent(value)+
        (store.searchInput.dates === null ? "" : "&sd=" + store.searchInput.dates[0] + "&ed=" + store.searchInput.dates[1])

    }
};

class GoogleScholarSearcher extends NoInlineResultSearcher {
    key = 'google scholar';
    searcherName = 'Google Scholar';
    infoText = 'Google Scholar';
    typeFilter2urlSection = {"All types": null};
    multiTypeFilterSupported = false;
    dateFilterSupported = false;

    fillTargetWebsiteUrl(value, store) { 
        this.targetWebsiteUrl = "https://scholar.google.com/scholar?q=" + 
        encodeURIComponent(value)+
        (store.searchInput.dates === null ? "" : "&as_ylo=" + store.searchInput.dates[0] + "&as_yhi=" + store.searchInput.dates[1])

    }
}; 

export {JstorSearcher, GoogleScholarSearcher}